exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".banner-row{display:none}@media (min-width:961px){.banner-row{flex-wrap:nowrap;margin:10px auto;display:flex;justify-content:flex-start;align-items:center;max-width:1170px}.banner-row.wrapper{padding:0}.banner-row .banner-static{padding:0 10px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/sass-loader/dist/cjs.js??ref--1-3!./components/banner-row/banner-row.scss
// module id = 554
// module chunks = 0